export default function HeroSection() {
  return (
    <section className="pt-48 pb-32 px-20 max-w-[1440px] mx-auto">
      <div className="flex items-center gap-16">
        <div className="flex-1">
          <div className="text-sm text-[#8B6F47] font-medium mb-8 tracking-wide">
            /iOS Development Experts
          </div>
          
          <h2 className="text-7xl font-light text-[#3A2E2E] leading-tight mb-8">
            Crafting Premium<br />
            iOS Experiences
          </h2>
          
          <p className="text-lg text-[#6B6B6B] leading-relaxed max-w-[480px]">
            We are a dedicated team of experts specializing in modern iOS application development. Our mission is to create innovative solutions that enhance user experience and improve the security of mobile devices across the globe.
          </p>
        </div>

        <div className="flex-1 flex justify-end">
          <div className="w-full max-w-[560px] bg-white/95 rounded-[32px] shadow-[0_8px_40px_rgba(0,0,0,0.06)] p-6 overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/1209bb62a04a97ff1450bf2640071e59.jpg"
              alt="iOS Development Illustration"
              className="w-full h-full object-cover rounded-3xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
